export * from "./advert-of-interest.dto.interface";
